module.exports = __webpack_public_path__ + "img/logo-lion-air.6432be37.png";